import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import {
  Paper,
  IconButton,
  Typography
} from '@material-ui/core'
import Icon from '../../../../components/atoms/Icon'

const useStyles = makeStyles((theme) => ({
  panelWrapper: {
    height: '100%',
    overflow: 'hidden',
    flex: '1 0',
    display: 'flex',
    animation: '$slideIn 0.3s ease-out'
  },
  '@keyframes slideIn': {
    from: {
      opacity: 0,
      transform: 'translateX(100px)'
    },
    to: {
      opacity: 1,
      transform: 'translateX(0)'
    }
  },
  panel: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    borderLeft: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden',
    boxShadow: '-2px 0 4px rgba(0, 0, 0, 0.1)'
  },
  panelHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 'var(--padding-md)',
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: 'var(--color-texture-300)',
    // minHeight: 56, // Match typical toolbar height
    flexShrink: 0
  },
  panelContent: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  panelTitle: {
    fontWeight: 500,
    fontSize: '1.1rem',
    color: theme.palette.text.primary
  },
  closeButton: {
    marginLeft: theme.spacing(1)
  }
}))

export function AttachmentPanel ({ open, onClose, title, children, width = '50%', headerActions }) {
  const classes = useStyles()

  if (!open) return null

  return (
    <div
      className={classes.panelWrapper}
      style={{
        width: width
      }}
    >
      <Paper
        className={classes.panel}
        elevation={0}
      >
        <div className={classes.panelHeader}>
          <Typography className='font-serif font-size-lg' variant='h6'>
            {title || 'Attachment'}
          </Typography>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {headerActions}
            <IconButton
              onClick={onClose}
              className={classes.closeButton}
              size='small'
              aria-label='Close attachment viewer'
            >
              <Icon name='close' />
            </IconButton>
          </div>
        </div>

        <div className={classes.panelContent}>
          {children}
        </div>
      </Paper>
    </div>
  )
}

AttachmentPanel.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  width: PropTypes.string,
  headerActions: PropTypes.node
}
